
import css from 'styled-jsx/css';

export default css`.editorial-stories {
  display: grid;
  grid-column: content;
  width: 100%;
  max-width: $container-max-width;
  padding: 3.5rem 0;
  margin: 0 auto;

  @include media-query(tablet) {
    padding: 5rem 0;
  }

  @include media-query(desktop) {
    padding: 6.25rem 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include media-query(mobile) {
      align-items: flex-end;
    }
  }

  &__header + &__body {
    margin-top: 2.5rem;

    @include media-query(tablet) {
      margin-top: 4rem;
    }
  }

  &__view-all-link {
    min-width: 90px;
  }
}

:global(.editorial-stories__heading > span) {
  @include media-query(mobile) {
    max-width: 220px;
  }
}

:global(.editorial-stories__body > .editorial-story-grid) {
  padding: 0;
}
`